import { Container, PageHeading } from '~/components'

import { PrivacyPolicyContent } from '../components'

export const PrivacyPolicyPage = () => {
  return (
    <main className="pb-36 pt-6 md:pt-10">
      <Container className="flex flex-col gap-y-10">
        <PageHeading>プライバシーポリシー</PageHeading>
        <section>
          <PrivacyPolicyContent />
        </section>
      </Container>
    </main>
  )
}
